import app from 'flarum/forum/app';
// FLARUM 2.0: extend FormModal, not Modal. 2.0 split the <form> wrapper out of
// Modal into FormModal (wrapper() -> <form onsubmit>, plus onready() focusing
// the first input). Extending plain Modal renders no <form>, so the
// type="submit" Insert button submitted nothing and onsubmit() never ran:
// the modal opened, accepted input, and silently did nothing. Found in a
// browser (A4).
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

/**
 * Shared modal for inserting an image or link via prompted URL + display text,
 * replacing the GitHub-style two-step `[ ](https://)` toolbar behavior.
 *
 * Attrs:
 *   - kind:        'image' | 'link'
 *   - initialUrl:  string (prefilled if the user had a URL selected in the composer)
 *   - initialText: string (prefilled with selected text — alt text for image, link text for link)
 *   - onsubmit:    (markdown: string) => void
 */
export default class UrlInsertModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.kind = this.attrs.kind === 'image' ? 'image' : 'link';
    this.url = Stream(this.attrs.initialUrl || '');
    this.text = Stream(this.attrs.initialText || '');
  }
  className() {
    return 'UxTweaksUrlInsertModal Modal--small';
  }
  title() {
    return app.translator.trans(`fixedgr-ux-tweaks.forum.${this.kind}_modal.title`);
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans(`fixedgr-ux-tweaks.forum.${this.kind}_modal.url_label`)), m("input", {
      className: "FormControl",
      type: "url",
      bidi: this.url,
      autocomplete: "off",
      placeholder: app.translator.trans(`fixedgr-ux-tweaks.forum.${this.kind}_modal.url_placeholder`),
      autofocus: true
    })), m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans(`fixedgr-ux-tweaks.forum.${this.kind}_modal.text_label`)), m("input", {
      className: "FormControl",
      type: "text",
      bidi: this.text,
      autocomplete: "off",
      placeholder: app.translator.trans(`fixedgr-ux-tweaks.forum.${this.kind}_modal.text_placeholder`)
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      disabled: !this.url().trim()
    }, app.translator.trans('fixedgr-ux-tweaks.forum.insert_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    const url = this.url().trim();
    if (!url) return;
    const text = this.text();
    // Escape characters that would break the link's text/url syntax. Newlines in
    // alt/text are stripped because markdown links don't render them.
    const safeText = text.replace(/\r?\n/g, ' ').replace(/[\[\]]/g, '\\$&');
    const safeUrl = url.replace(/\s/g, '%20').replace(/\)/g, '%29');
    const prefix = this.kind === 'image' ? '!' : '';
    const markdown = `${prefix}[${safeText}](${safeUrl})`;
    if (typeof this.attrs.onsubmit === 'function') {
      this.attrs.onsubmit(markdown);
    }
    this.hide();
  }
}
flarum.reg.add('fixedgr-ux-tweaks', 'forum/components/UrlInsertModal', UrlInsertModal);